import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isNull } from 'lodash';
import CheckExcelBulkDeliveryDispatchResultModal from '../../../../views/order/common/modal/CheckExcelBulkDeliveryDispatchResultModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class CheckExcelBulkDeliveryDispatchResultModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredList: props.data.excelBulkDeliveryInfoOrderItemList,
      filteredStoreId: null,
      filteredOrderItemId: null,
      filteredInvoiceNumber: null,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'checkExcelBulkDeliveryDispatchResultModal',
    });
  };

  onFilter = (name, filteredName, value) => {
    const { excelBulkDeliveryInfoOrderItemList } = this.props.data;

    this.setState({
      ...this.state,
      [filteredName]: value,
      filteredList: !isNull(value)
        ? excelBulkDeliveryInfoOrderItemList.filter((item) => item[name] && item[name].toString().includes(value))
        : excelBulkDeliveryInfoOrderItemList,
    });
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <CheckExcelBulkDeliveryDispatchResultModal
        {...this.state}
        isOpen={isOpen}
        data={data}
        onFilter={this.onFilter}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.checkExcelBulkDeliveryDispatchResultModal.isOpen,
    data: state.order.checkExcelBulkDeliveryDispatchResultModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(CheckExcelBulkDeliveryDispatchResultModalContainer));
